export default {
  home: {
    openFinance: '重新构想',
    description: '具有机构级流动性，安全、快速、无 Gas 的链上交易',
    gasFees: 'Gas 费用',
    whyHelix: '为何选择 Helix?',
    reimagined: '开放式金融',
    latestNews: '最新消息',
    totalVolume: '总交易量',
    totalMarkets: '总市场数量',
    startTrading: '开始交易',
    helixDocs: 'Helix 文档',
    somethingIsBrewing: '好消息酝酿中',
    builtForTheCommunity: '专为社区打造',
    builtForTheCommunityDescription: '没有投资者，没有风险资本，没有废话。',
    downloadHelixMobile: '在 iOS 或 Android 下载 Helix 行动应用',
    overview: {
      title: '为何选择 Helix?',
      lpRewardsTitle: 'LP 奖励',
      tradingBotsTitle: '交易机器人',
      gasFreeTitle: '无 Gas 交易',
      tradeStocksTitle: '交易股票和现实世界资产',
      lpRewardsDescription: '提供流动性并获得报酬。',
      description: '作为顶级交易所打造，但完全去中心化。',
      gasFreeDescription: '永远无需担心 Helix 的 Gas 费用。始终无 Gas。',
      tradingBotsDescription: '只需单击即可部署先进的智能链上交易策略。',
      tradeStocksDescription:
        '使用加密货币交易股票和现实世界资产 (RWA)，实现更快、更便宜、更透明的交易。'
    },
    gettingStarted: {
      title: '快速入门 Helix',
      injectiveBridge: 'Injective 跨链桥',
      description: '将加密资产存入 Injective ',
      description2: '通过 {bridgeLink} 将 USDT 和其他资产跨链到 Helix。',
      gasRequirement: '确保您拥有至少 0.1 INJ 来支付跨链费用。',
      step1: {
        title: '步骤一',
        description: '访问 Injective 跨链桥并连接您的钱包。'
      },
      step2: {
        title: '步骤二',
        description: '选择源链，例如以太坊、Cosmos 或 Solana。'
      },
      step3: {
        title: '步骤三',
        description: '选择 USDT 或任何其他资产'
      },
      step4: {
        title: '步骤四',
        description:
          '跨链完成后，返回 Helix 并在投资组合页面查看您的余额。您已准备好进行交易！'
      }
    },
    mobile: {
      usp1: '新手友善',
      title: '随时随地皆可交易',
      usp2: '加密资产、股票、大宗商品和外汇',
      downloadHelixMobile: '下载 Helix 行动应用'
    },
    faq: {
      title: '常见问题',
      or: '或',
      on: '在',
      and: '和',
      here: '此',
      fullstop: '。',
      accordion1: {
        title: 'Helix 提供了哪些服务？',
        featureTitle:
          'Helix 提供无缝且强大的交易体验，具有先进的功能和灵活性：',
        stocks: '股票',
        lpRewards: 'LP 奖励',
        commodities: '大宗商品',
        spotMarkets: '现货市场',
        tradingBots: '交易机器人',
        autoSigning: '自动签署',
        makerRebates: '吃单返佣',
        feeDiscounts: '费用折扣',
        oneHundredLeverage: '100x 杠杆',
        perpetualMarkets: '永续市场',
        tradingCompetitions: '交易竞赛',
        feature1: '在 {spotMarkets} 交易头部加密资产交易对',
        feature2:
          '在 {perpetualMarkets} 上使用高达 {oneHundredLeverage}，包括加密货币、{stocks} 和黄金和白银等 {commodities}。',
        feature3: '使用内置的{tradingBots}自动化您的现货和永久市场策略。',
        feature4:
          '通过质押 INJ，通过 {lpRewards}、{makerRebates} 和 {feeDiscounts} 赚取收益。',
        feature5: '通过 {autoSigning} 享受顺畅的交易流程和无气体验。',
        feature6: '参加频繁的 {tradingCompetitions} 并解锁独家奖励。'
      },
      accordion2: {
        title: '如何将资产存入 Helix？',
        optionTitle:
          '要开始在 Helix 上交易，您首先需要在 Injective 上获取 USDT 或 INJ 等资产：',
        fiatOnRamps: '法币入口',
        injectiveBridge: 'Injective 跨链桥',
        option1:
          '通过 {fiatOnRamps} 购买加密货币（通过借记卡/信用卡、Revolut、Apple Pay、Google Pay 等）。',
        option2: '使用 {injectiveBridge} 存入来自其他链的资产。',
        option3:
          '或者，您也可以从不同的中心化交易所（如 Binance、ByBit 等）进行存款。'
      },
      accordion3: {
        title: '如何在 Helix 上交易加密资产？',
        stepTitle:
          '在 Helix 上交易快速、无需许可，而且完全免 Gas 费用。以下是开始操作方法：',
        inj: 'INJ',
        spot: '现货',
        usdt: 'USDT',
        limit: '限制',
        helix: 'helixapp.com',
        perpetual: '永续',
        marketOrder: '市价单',
        videoTutorialHere: '此处观看视频教程',
        step1: '前往 {helix} 并连接您的钱包。',
        step2: '存入或跨链资产，如 {usdt} 或 {inj}。',
        step3: '选择您想要交易的 {spot} 或 {perpetual}市场。',
        step4: '只需点击几下即可下达 {limit} 或 {marketOrder}。',
        cta: '想要完整的教程吗？查看我们的分步 {tutorial}。'
      },
      accordion4: {
        title: '是否有 Helix Mobile App？我在哪里可以获取它？',
        appStore: 'iOS（应用商店）',
        playStore: 'Android（Google Play）',
        description:
          'Helix Mobile 在 {appStore} 和 {playStore} 上免费。安装应用并连接您的钱包，您就能看到与网页版相同的市场和余额。'
      },
      accordion5: {
        title: '我该如何在 Helix Mobile 上连接钱包？',
        description: '您有三个选择：',
        option1:
          '扫描二维码 - 打开 Helix Mobile，点击“扫描 Helix 网页上的二维码”，然后将相机对准设置中 Helix 网页应用上显示的二维码。（链接到 ACM 中的 AuthZ 模块）',
        option2:
          '使用您现有的社交应用登录 - 使用您在桌面上使用的相同 Google 或 Apple 帐户登录，您的钱包会立即出现。',
        option3:
          '创建一个全新的钱包 - 如果您想从头开始，请生成一个与您的电子邮件绑定的全新非托管钱包。'
      },
      accordion6: {
        title: ' Helix Mobile 如何保证我的资产安全？',
        description:
          'Helix Mobile 应用完全非托管。私钥保留在您的设备上，交易在本地签名，您可以在设置中添加生物识别双因素验证。Helix 绝不会扣留您的资金或助记词——其安全性与网页端完全相同。对于社交登录，密钥由业界标准的密钥管理工具 Turnkey 安全存储。'
      }
    }
  },
  swap: {
    fees: '费用',
    rate: '汇率',
    title: '闪兑',
    route: '路径',
    youPay: '您支付',
    youReceive: '您获取',
    backToSwap: '回到闪兑页面',
    enterAmount: '输入数量',
    maximumInput: '最大输入',
    tolerance: '滑点容差',
    minimumOutput: '最小输出',
    connectWallet: '连接钱包',
    expectedOutput: '预期输出',
    viewTransaction: '查看交易',
    advancedSettings: '进阶设置',
    currentlyOffline: '当前离线',
    swapTime: '闪兑（{swapTimeRemaining}s）',
    somethingWentWrong: '发生错误。',
    swappedSuccessfully: '闪兑成功！',
    rateExpired: '汇率过期。点击更新',
    swapAmountTooLow: '闪兑金额过低',
    insufficientLiquidity: '流动性不足',
    pleaseTryAgain: '请重新加载页面后再试。',
    tooltip: '如果价格变化超过该百分比，您的交易将被自动取消。',
    youHaveSwapped:
      '您已将 {inputAmount} {inputTokenSymbol} 闪兑为 {outputAmount} {outputTokenSymbol}',
    priceWarning:
      '检测到高滑点！请您仅在您了解可能收到的 {symbol} 少于预期的情况下才继续。'
  },
  guild: {
    title: '公会',
    description:
      'Helix 公会是一项基于团队的交易竞赛。加入强者战队，一起赢取荣耀与奖励！',
    rewardDescription1:
      '每个公会将根据 TIA/USDT 市场的总交易量与成员的加权平均 TIA 持仓进行排名，两个榜单的第一名将分别获得 500 INJ 与 5,000 TIA 奖励。',
    rewardDescription2:
      '每个公会最多仅限 150 名成员，立即加入，确保您不会错过参赛资格！',
    inactiveDescription:
      '在公会长的 TIA 持仓达到 {amount} TIA 之前，公会所产生的交易量将不计入排行榜。',
    inactiveTooltip: '公会长 TIA 持仓低于 {amount} TIA',
    you: '您',
    guilds: '公会',
    noData: '查无数据',
    endsIn: '结束于',
    rewards: '奖励',
    readyIn: '准备于',
    startsIn: '开始于',
    seasonEnded: '赛季已结束',
    startOn: '开始于 {date}',
    participants: '参与者',
    totalRewards: '总奖励',
    showInactive: '显示非活跃工会',
    currentSeason: '当前赛季',
    campaignRules: '活动规则',
    seasonOneEnded: '第一赛季已结束',
    howToParticipate: {
      title: '如何参与',
      createGuild: {
        cta: '创建公会',
        title: '成为公会长，邀请他人加入您的战队！',
        description:
          '比赛期间钱包中至少持有 {amount} TIA，若所在公会获胜，可获得 20% 奖励！'
      },
      joinGuild: {
        cta: '加入 Injective Discord',
        title: '加入公会，与好友并肩赢取奖励！',
        description:
          '提升 TIA 持仓与交易量，带领公会冲榜！若公会获胜，可与好友共享 80% 奖励！',
        description2:
          '前往 Discord 的 #helix-guilds 频道查找公会，或向朋友索取邀请码加入！'
      }
    },
    leaderboard: {
      title: '排行榜',
      guildMembers: '公会成员',
      fetchNewData: '检索新数据',
      invitationCode: '邀请码',
      lastUpdated: '最后更新于 {date}',
      guildMasterAddress: '公会长地址',
      guildMasterBalance: '公会长当前 TIA 余额',
      tab: {
        rankByVolume: '按交易量排名',
        rankByTVL: '按 TIA 持仓排名'
      },
      table: {
        rank: '排名',
        guild: '公会',
        status: '状态',
        balance: '余额',
        members: '成员',
        address: '地址',
        volumeRank: '交易量排名',
        tvlRank: 'TIA 余额排名',
        tradingVolume: '交易量',
        totalTIABalance: '总 TIA 余额',
        totalTradingVolume: '总交易量',
        weightedAverageTiaBalance: 'TIA 加权平均余额',
        tiaBalanceTooltip: '比赛期间地址中所持有 TIA 的加权平均值',
        volumeTooltip: '比赛期间该地址所产生的吃单与挂单交易量'
      }
    },
    createGuild: {
      cta: '创建公会',
      title: '创建一个公会',
      characters: '角色',
      name: '公会名称',
      namePlaceholder: '输入名称',
      description: '公会描述',
      thumbnail: '选取公会缩图',
      masterAddress: '公会长地址',
      findAGuildToJoin: '寻找公会加入',
      insufficientBalance: '余额不足',
      balanceInWallet: '钱包中 {symbol} 余额：',
      insufficientBalanceDescription:
        '公会长必须在整个比赛期间（包括创建公会时）钱包中始终持有不少于 {amount} {symbol}。'
    },
    joinGuild: {
      cta: '加入公会',
      maxCap: '人数上限',
      title: '在 Helix 上加入公会',
      invitationCode: '在 Discord 获得邀请码d',
      description: '加入 Helix 上的 "{name}" 公会，赢取专属奖励份额！'
    },
    verifyJoinGuild: {
      cta: '加入',
      hash: '邀请码',
      title: '输入邀请码',
      incorrectCode: '邀请码错误',
      hashPlaceholder: '输入邀请码',
      description: '请输入邀请码以加入该公会。'
    },
    alreadyPartOfGuild: {
      title: '已为公会成员',
      description:
        '{address} 已加入一个公会。比赛期间，每个地址只能加入一个公会。'
    }
  },
  toast: {
    error: '错误',
    success: '成功',
    addressCopied: '已复制地址',
    viewOnInjScan: '在 InjScan 上查看',
    contextCopied: '已复制内容！',
    marketIdCopied: '已复制市场 ID',
    somethingHappened: '发生错误...',
    connectedSuccessfully: '已成功连接 ',
    copiedAddressToClipboard: '地址已成功复制至剪贴簿',
    formSubmittedSuccessfully: '表单已成功提交。',
    transactionFinalized:
      '{viewOnInjScan}交易在 {duration} 秒内完成。{viewOnInjScan}',
    onramperSuccess:
      '成功！您以 {fiatCurrency} 购买了 {cryptoAmount} 枚 {crypto} 代币。代币正在发送中。',
    account: {
      authZAdded: 'AuthZ 账户已添加',
      assetsTransferred: '资产已转入您的账户',
      transferToSubaccountSuccess: '子账户转移成功'
    },
    authz: {
      connectedAs: '连接为'
    },
    portfolio: {
      buyInj: '购买 INJ',
      bridgeNow: '马上跨链',
      bankTransferSuccessful: '转账成功',
      startTradingInSeconds: '在数秒钟内开始交易！',
      readyToTrade: '准备好交易了吗？立即探索市场！',
      moveAssetsToInj: '将资产从以太坊转移到 Injective',
      discoverTrendingPairs: '发现热门交易对并开始交易',
      moveAssetsToInjTitle: '将您的加密货币转移到 Injective 并开始交易',
      topUpWithCreditOrDebit: '使用信用卡或借记卡充值并立即开始交易。',
      autoSign: {
        disabledToast: '自动签名已停用',
        enabledToast: {
          title: '自动签名已启用',
          description: '自动签名已启用 3 日。'
        },
        enable: {
          title: '自动签名',
          description:
            '一旦启用，您就可以更顺利地在 Helix 上进行交易，而无需签署每笔交易。'
        }
      }
    },
    trade: {
      invalidPrice: '价格不可用',
      orderCancelled: '订单已取消',
      positionClosed: '仓位已关闭',
      noLiquidity: '流动性不足',
      orderPlaced: '已成功下达订单',
      tpSuccessMessage: '止盈价格设置为 {price}',
      slSuccessMessage: '止损价格设置为 {price}',
      allOrdersCancelled: '已取消所有订单',
      orderUpdated: '订单已更新成功',
      slOrderCancelled: '已取消止损订单',
      successAddedMargin: '已成功添加保证金',
      tpOrderCancelled: '已取消止盈订单',
      advancedOrderCancelled: '高级订单已取消',
      allAdvancedOrdersCancelled: '所有高级订单已取消',
      rwaMarketClosedToast:
        '该市场当前已关闭。您仍可进行交易，但请注意相关风险。',
      neptuneUsdt: {
        success: {
          deposit: 'Neptune 存款成功',
          withdraw: 'Neptune 提现成功'
        }
      },
      tradeToast: {
        sold: '已卖出 {quantity} {symbol}，平均价格为 ${usdPrice}',
        bought: '已买入 {quantity} {symbol}，平均价格为 ${usdPrice}'
      }
    },
    referral: {
      referralLinkCopied: '推荐链接已复制',
      referralLinkIsUnavailable: '推荐链接不可用',
      success: '推荐码成功领取。立即探索市场！',
      referralLinkExists: '您已经为该钱包应用了另一个推荐码',
      joinSelfReferralMessage:
        '推荐码有效，但您无法推荐自己。请分享给其他人使用！'
    },
    leaderboard: {
      receivedInformation: '我们已收到您的信息，团队将尽快与您联系'
    },
    campaign: {
      errorAlreadyClaimed: '奖励已领取',
      notFound: '活动未找到，请稍后重试',
      successfullyClaimedRewards: '奖励领取成功'
    },
    guild: {
      successfullyJoinGuild: '成功加入公会',
      successfullyCreateGuild: '成功创建公会',
      copiedInvitationLink: '邀请码已复制到剪贴板'
    },
    tradingBots: {
      tradingBotRemovedSuccessfully: '交易机器人移除成功',
      tradingBotCreatedSuccessfully: '交易机器人创建成功'
    },
    stockTwits: {
      startHere: '从这里开始',
      title: '👋 初次使用 Helix？',
      description: '轻松开始交易加密货币和代币化股票'
    }
  },
  trade: {
    tp: '止盈',
    sl: '止损',
    fee: '手续费',
    buy: '买入',
    max: '最大',
    size: '数量',
    info: '信息',
    long: '做多',
    sell: '卖出',
    spot: '现货',
    time: '时间',
    open: '开仓',
    sold: '已卖出',
    tpSl: '止盈/止损',
    chase: '追价',
    price: '价格',
    total: '总计',
    limit: '限价',
    short: '做空',
    chart: '图表',
    depth: '深度',
    trade: '交易',
    amount: '数量',
    filled: '已成交',
    market: '市价',
    trades: '成交记录',
    margin: '保证金',
    volume: '交易量',
    bought: '已买入',
    markets: '市场',
    details: '详情',
    quantity: '数量',
    leverage: '杠杆',
    standard: '标准',
    addTpSl: '添加止盈/止损',
    tickSize: '最小价格单位',
    stopLoss: '止损',
    postOnly: '仅挂单',
    noTrades: '暂无成交',
    noOrders: '暂无订单',
    notAvailableNA: '无',
    avgPrice: '暂无订单',
    direction: '方向',
    orderbook: '订单簿',
    editTpSl: '编辑止盈/止损',
    triggered: '已触发',
    cancelled: '已取消',
    markPrice: '标记价格',
    cancelAll: '取消所有',
    addMargin: '追加保证金',
    viewOrder: '查看订单',
    'pro-chart': '专业图表',
    allMarkets: '全部市场',
    marketName: '市场名称',
    takeProfit: '止盈',
    limitPrice: '限价',
    worstPrice: '最差价格',
    entryPrice: '开仓价格',
    reduceOnly: '仅减仓',
    profitLoss: '盈亏',
    balanceTitle: '可用余额',
    openOrders: '挂单',
    reduce_only: '仅减仓',
    'stop-limit': '限价止损',
    derivatives: '衍生品',
    liquidation: '强平',
    tickerOnly: '仅 {ticker}',
    cancelOrder: '取消订单',
    showHistory: '查看历史记录',
    makerRate: '挂单费率',
    maxLeverage: '最大杠杆',
    'stop-market': '市价止损',
    confirmTpSl: '确认止盈/止损',
    triggerPrice: '触发价格',
    averagePrice: '平均价格',
    'trading-bots': '交易机器人',
    emptyOrders: '未找到订单',
    emptyTrades: '未找到成交记录',
    totalNotional: '名义总额',
    closePosition: '平仓',
    estFeeRebate: '预估手续费返佣',
    partialFilled: '部分成交',
    proceedAnyway: '仍要执行',
    stopLossLimit: '限价止损',
    searchMarket: '搜索市场...',
    boostedMarkets: '奖励市场',
    priceDeviation: '价格偏离',
    pnlPercent: '浮动盈亏比例（持仓）',
    stopLossMarket: '市价止损',
    cancelStopLoss: '取消止损单',
    availableMargin: '可用保证金',
    partiallyFilled: '部分成交',
    cancelAllOrders: '取消所有订单',
    takeProfitLimit: '限价止盈',
    enterYourAmount: '请输入数量',
    advancedSettings: '高级设置',
    totalVolume: '总交易量 ({symbol})',
    stopLossQuantity: '止损数量',
    takeProfitMarket: '市价止盈',
    cancelTakeProfit: '取消止盈单',
    availableAmount: '可用数量: {amount}',
    makerTakerRate: '挂单/吃单费率',
    sharePnl: '分享 PNL',
    noOpenOrders: '查无订单',
    noOrderHistory: '查无订单历史',
    noTradeHistory: '查无交易历史',
    noOpenPositions: '查无仓位',
    slippageTolerance: '滑点容差',
    previousMarkPrice: '前一标记价格',
    totalQuantitySize: '总下单数量',
    marketsInformation: '市场信息',
    minLimitOrderSize: '最小限价订单数量',
    bypassPriceWarning: '忽略价格预警',
    totalQuantity: '总数量 ({symbol})',
    takeProfitQuantity: '止盈数量',
    disqualifiedMarkets: '不合格市场',
    estLiquidationPrice: '预估强平价格',
    stopLossTriggerPrice: '止损触发价格',
    emptyAdvancedOrders: '暂无高级订单',
    takeProfitTriggerPrice: '止盈触发价格',
    modifyTakeProfitStopLoss: '修改止盈/止损',
    postOnlyWarning: '由于主网升级，目前仅限挂单',
    minNotionalError: '最小下单金额需大于 > {minNotional} {symbol}',
    doNotShowThisConfirmationAgain: '不再显示此确认提示',
    availableMarginTooltip: '您可为该仓位追加的可用保证金',
    thereAreNoDisqualifiedMarketsOnThisRelayer: '本交易所无不合格市场',
    tensMultiplierRounded: '自动向下取整为 {minTickSize} 的整数倍',
    markPriceInvalid: '请修改价格、数量或杠杆以符合标记价格要求',
    eip712Warning: '由于网络使用量激增，当前暂停免 Gas 签名交易',
    slippageTooltip: '滑点容差是指在取消交易前允许的最大价格变动',
    stopLossDetails:
      '当标记价格达到 {price} 时，将触发数量为 {quantity} 的市价止损订单',
    takeProfitDetails:
      '当标记价格达到 {price} 时，将触发数量为 {quantity} 的市价止盈订单',
    slippageWarning: '若滑点设置过高，您的交易可能会以不利价格成交',
    positionUsedTooltip: '{quantity} 已用于其他订单。您可取消或修改当前挂单',
    disqualifiedMarketsTooltip:
      '这些市场不计入 Trade & Earn 活动。交易这些市场无法获得积分',
    worstPriceTooltip:
      '最差价格代表在滑点范围内，买入时可能支付的最高价或卖出时收到的最低价',
    chaseTooltip:
      '点击追价可将当前限价订单修改为最新最佳买一/卖一价格。启用自动签名后可使用该功能',
    boostedMarketsTooltip:
      '奖励市场中挂单和吃单可获得奖励积分。例如“3x maker pts”表示挂单交易将获得手续费价值 3 倍的奖励积分',
    tab: {
      orders: '订单',
      balances: '余额',
      positions: '仓位',
      openOrders: '挂单',
      orderHistory: '订单历史',
      tradeHistory: '成交历史',
      advancedOrders: '高级订单',
      fundingHistory: '资金费率历史',
      activeStrategies: '运行中的策略',
      removedStrategies: '已移除的策略'
    },
    rwa: {
      closed: '已关闭',
      nyseClosedTimes: '纽约证券交易所交易时间',
      statusOfThisMarket: '该市场状态',
      rwaClosedTimes: ' 传统 RWA 价格更新时段',
      nyseClosedMarketRow: '该市场遵循纽约证券交易所交易时间',
      thisMayIncreaseYourTradingRisk: '这可能会增加您的交易风险',
      rwaClosedMarketRow: '该市场遵循传统 RWA 价格更新时段',
      acknowledge: '我理解并接受风险，愿意继续交易',
      tradesCanBePlace: '您可以在非交易时间下单，但市场重开前价格将不会更新',
      nyseMarketClosedTrade:
        'Helix 上所有市场均可全天候交易。但需注意，该市场遵循 {nyseClosedTimes}，即协调世界时 14:30 至 21:00（UTC），夜间、周末及 NYSE 节假日休市。',
      marketClosedTrade:
        'Helix 上所有市场均可全天候交易。但需注意，该市场遵循 {marketClosedTimes}。市场在每周五美东时间下午 5 点至周日美东时间下午 5 点关闭，CME 节假日关闭，以及周一至周四每日美东时间下午 5 点至 6 点之间暂停。'
    },
    stats: {
      low: '24 小时最低价',
      high: '24 小时最高价',
      usdValue: '美元价值',
      marketCap: '市值',
      annualized: '年化',
      nextFunding: '下一次资金费率',
      volumeInUsd: '美元交易量（24 小时）',
      marketVolume24h: '交易量（24 小时）',
      estFundingRate: '预估资金费率',
      marketCapTooltip:
        '市值通过当前价格乘以当前流通供应量计算得出。Injective 上部分代币没有最大供应量限制。',
      fundingRateTooltip:
        '资金费率根据永续合约价格与现货价格的差额计算。如果为正，做多方向做空方支付；若为负，做空方向做多方支付。',
      markPriceTooltip:
        '用于保证金计算、未实现盈亏（PNL）、资金费率、强平和止盈止损订单的标记价格。'
    },
    marketMultiplierBanner: {
      description:
        '该市场将从 {startDate} 起，在 {duration} 小时内为 “Like a G” 交易竞赛提供 {multiplier} 倍积分加成。加成效果稍后将反映在排行榜中。适用{terms}条款。'
    },
    equity: {
      spot: '现货',
      perps: '永续合约',
      title: '账户权益',
      unrealizedPnl: '未实现盈亏'
    },
    neptuneUsdt: {
      apy: 'APY',
      submit: '提交',
      deposit: '存入',
      neptune: 'Neptune',
      withdraw: '提取',
      available: '可用',
      deposited: '已存入',
      availableUSDT: '可用 USDTT',
      depositToNeptune: '存入 Neptune',
      percentageInReserve: '（15% 保留）',
      automatedYields: 'Helix 自动收益',
      withdrawFromNeptune: '从 Neptune 提取',
      availableUsdt: '≈{peggyUsdt} USDT + {neptuneUsdt} Neptune USDT',
      apyTooltip:
        '这是 Neptune 当前为 USDT 存款提供的年化收益率。该数值会随时间变化。',
      banner:
        'Helix 与 Neptune 合作，让您无需离开平台即可轻松赚取稳定币收益。点击 {here} 开始操作',
      description:
        '将稳定币存入 {link} 上的 USDT 借贷池，在不离开 Helix 的情况下自动赚取收益。当您准备交易时，资金将自动从借贷池中提取，无需额外操作。',
      warningText:
        '继续操作即表示您将资金存入一个非 Injective 控制或关联的应用程序。您需自行承担所有使用风险，并同意 Injective 无需为任何可能的损失负责。详情请参阅 Helix 的 {terms}。'
    },
    iAssetModal: {
      cta: '开始交易',
      title: '释放 iAssets 的强大力量！',
      description:
        '率先在全球顶级去中心化交易所交易链上股票期货，支持高达 25 倍杠杆。'
    },
    marketRestricted: {
      tradeSpot: '交易现货',
      cta: '返回首页',
      swapCta: '{symbol} 在您所在地区不可用。',
      title: {
        spot: '{symbol} 受限',
        perpetual: '永续合约交易受限'
      },
      description: {
        spot: '由于监管限制，{symbol} 在您所在地区不可用。',
        perpetual:
          '由于监管限制，永续合约在您所在地区不可用。但您仍可交易现货市场。'
      }
    },
    marketNotOnHelix: {
      cta: '我已了解',
      title: '实验性市场',
      termsAndCondition: '用户条款',
      description:
        '您正在访问 Injective 上可用但未在 Helix 上列出的市场。请确认该 Market ID 是否为您希望交易的市场。',
      description2: '继续操作即表示您已阅读并同意 Helix 的 {0}，并将受其约束。'
    },
    sharePnlModal: {
      markPrice: '标记价格',
      entryPrice: '入场价格',
      mobileDownloadNote: '可在桌面上下载'
    },
    partialClosePositionModal: {
      limitClose: '限价平仓',
      marketClose: '市价平仓',
      marketTitle: '部分平仓',
      totalPositionSize: '总持仓规模'
    },
    table: {
      markets: {
        markets: '市场',
        'last-price': '最新价格',
        'market-change-24h': '24 小时涨跌',
        'market-volume-24h': '24 小时交易量'
      },
      marketsSelector: {
        markets: '市场',
        'last-price': '最新价格',
        'market-volume-24h': '24 小时交易量',
        'market-change-24h': '24 小时涨跌',
        'funding-rate': '预估资金费率（1 小时）'
      }
    }
  },
  vault: {
    TVL: 'TVL',
    APY: 'APY',
    title: '通过 Mito 金库最大化收益',
    description:
      '通过 Mito 的自动化做市金库增强您的加密资产价值。向 Injective 生态领先项目提供流动性，从今天开始赚取被动收入。',
    item: {
      'mito-vault': 'LP 金库',
      'injective-staking': '质押',
      'helix-spot-grid-bot': '现货网格交易机器人'
    },
    modal: {
      continueToMito: '前往 Mito',
      redirect: '进入金库将从 Helix 跳转至 Mito，您可在其中赚取收益。'
    }
  },
  markets: {
    vol: '成交量',
    iAsset: 'iAsset',
    marketId: 'Market ID',
    showLowVol: '显示低交易量市场',
    newMarkets: '🐤 新市场',
    topGainers: '🚀 涨幅榜',
    closePositionWarningTitle: '检测到较大价格冲击',
    indexMarketTooltip: '该市场跟踪 {label}。更多详情请见 {link}。',
    buidlTooltip: '本产品为指数永续合约。详细信息请参考 {docs}。',
    closePositionWarningDescription:
      '使用市价单平仓可能导致不利的成交价格。建议考虑使用限价单进行平仓。',
    '2024ElectionTooltip':
      '该市场参考 Polymarket 的 2024 年总统大选市场价格，TRUMPWIN 为其基础资产。更多信息请访问 {docs}。',
    filters: {
      all: '全部',
      favorites: '收藏',
      perps: '永续合约',
      spot: '现货',
      trending: '热门',
      injective: 'Injective',
      'layer-1': 'L1',
      deFi: 'DeFi',
      ai: 'AI',
      rwa: 'RWA',
      iAssets: 'iAssets'
    }
  },
  connect: {
    beta: 'Beta',
    wallet: '钱包',
    trezor: 'Trezor',
    address: '钱包地址',
    ledgerLive: 'Ledger Live',
    trezorBip44: 'Trezor Bip44',
    getAddresses: '获取地址',
    ledgerLegacy: 'Ledger Legacy',
    walletAddress: '钱包地址',
    connectWallet: '连接钱包',
    derivationPath: '派生路径',
    showMoreWallets: '显示更多钱包',
    showLessWallets: '显示更少钱包',
    injectiveAddress: 'Injective 地址',
    getMoreAddresses: '获取更多地址',
    selectDerivationPath: '选择派生路径',
    connectUsingBrowser: '使用浏览器钱包连接',
    selectAddressToConnect: '选择要连接的地址',
    connectUsingHardware: '使用硬件钱包连接',
    connectDeprecatedSSO: '使用已弃用方式登录',
    qrTitle: '仅向此地址充值 INJ 网络资产',
    otpDescription: '请输入一次性验证码以验证您的邮箱',
    getAddressNote: '正在获取您的地址，请稍候...',
    pleaseConnectToYourWallet: '请连接您的钱包以查看更多详情',
    pleaseConnectToYourWalletCta: '请连接您的钱包以开始在 Injective 上交易！',
    connectUsingTrezorNote:
      '注意：为顺利连接您的 Trezor 硬件钱包，请确保您正在使用最新版 Chrome 浏览器，并且已连接并解锁 Trezor 设备。',
    connectUsingLedgerNote:
      '注意：为顺利连接您的 Ledger 硬件钱包，请确保您正在使用最新版 Chrome 浏览器，并且已连接并解锁 Ledger 设备，并打开 Ethereum 应用。',
    sso: {
      google: {
        cta: '使用 Google 登录'
      },
      email: {
        cta: '继续',
        placeholder: '您的邮箱地址'
      }
    },
    deprecate: {
      cta: '迁移钱包',
      title: '操作提示：请迁移您的钱包',
      description:
        '我们正在升级钱包服务商，您当前使用的钱包即将停止支持。强烈建议您按照以下指引完成钱包迁移。',
      migrateDescription:
        '我们升级了登录方式，使其更快速、更简便、更安全。要继续使用 Helix，请连接更新后的钱包迁移资产，仅需片刻，您的资金始终安全无虞。'
    },
    option: {
      leap: 'Leap',
      keplr: 'Keplr',
      ninji: 'Ninji',
      ledger: 'Ledger',
      phantom: 'Phantom',
      rainbow: 'Rainbow',
      metamask: 'Metamask',
      'trezor-bip32': 'Trezor',
      'trezor-bip44': 'Trezor Bip44',
      'okx-wallet': 'OKX Wallet',
      BitGet: 'Bitget Wallet',
      magic: '"Legacy login"',
      'trust-wallet': 'Trust Wallet',
      cosmostation: 'Cosmostation',
      'wallet-connect': 'Wallet Connect'
    }
  },
  points: {
    rank: '排名',
    level: '等级',
    share: '分享',
    title: '积分',
    period: '周期',
    points: '积分',
    volume: '交易量',
    totalPoints: '总积分',
    lastUpdatedAt: '最近更新时间：',
    myTotalPoints: '我在 Helix 的总积分',
    paginationDetails: '{from}-{to} 共 {total}',
    description: '第一赛季已结束。有关积分的更多信息，请参见',
    leagues: {
      blue: '蓝带',
      black: '黑带',
      white: '白带',
      orange: '橙带',
      purple: '紫带'
    }
  },
  banners: {
    findOutMore: '了解更多',
    stockTwits: '想了解如何进行交易或如何交易代币化股票？→ {learnMore}',
    deprecatedWallet: '该钱包已弃用。请按照迁移指南转移您的资金。{learnMore}',
    deprecatedWalletWithAddress:
      '该钱包已弃用。您的新 SSO 地址为 {address}。请按照迁移指南转移您的资金。{learnMore}',
    postOnly:
      '已启用仅挂单模式：由于主网升级，当前可下限价单，但 2000 个区块内不可下市价单或即时成交订单。{link}',
    settlePerpMarketBanner:
      '目前有一项治理提案拟强制结算该市场。建议您尽快平掉持仓，否则将在结算时按标记价格被强平。',
    settlePerpMarketBannerNewLaunch:
      '目前，WTI PERP 市场正在实施一项强制结算治理提案。建议您立即平仓，否则您的仓位将按结算时的标记价格强制结算。该市场结算完成后，将推出一个新的到期期货市场。',
    pointsS1Ended: 'Helix 积分第一赛季已结束。感谢您的参与，敬请期待更多更新！',
    kado: {
      getStarted: '立即开始',
      title: 'Helix 2.0 全新上线！探索焕然一新的交易体验。'
    },
    iAssets: {
      title: '在 Helix 上交易 iAssets',
      description:
        '使用加密货币交易股票，实现更快、更低成本、更透明的交易方式——融合传统市场与去中心化金融的力量。'
    },
    userFeedback: {
      threeMinutes: '3 分钟 ',
      notRightNow: '暂不需要',
      takeSurvey: '参与问卷',
      loveFeedback: '我们非常希望听到您的反馈！',
      thankYouEnd:
        '填写时间不超过数分钟，您的意见将帮助我们优化 Helix 的使用体验。',
      thankYouBeginning:
        '感谢您使用 Helix。我们一直致力于改进产品体验，期待您的宝贵建议！本问卷大约需时不超过 '
    },
    newFeature: {
      cta: '交易 TradFi',
      title: '全新上线 TradFi 股票指数！',
      description:
        '首次实现链上交易最大规模的上市股票，统一指数接入。全天候 24/7 访问传统金融市场，最低手续费，最高 25 倍杠杆，仅在 Helix。'
    },
    leaderboard: {
      currentCompetitionLink: 'Helix 奖池高达 $50K！',
      currentCompetitionTitle:
        '参与 Helix 交易挑战，争夺属于您的 {linkDescription}',
      gwagon: {
        blog: 'blog',
        ended: '已结束',
        title: 'Trade Like a G',
        description:
          '参与交易赢取 G-Wagon！活动时间为 10 月 1 日 14:00 UTC 至 10 月 22 日 14:00 UTC，两位幸运用户将分别获得一辆 G-Wagon：一辆奖励给 PnL 最高的交易员，另一辆将通过抽奖送出。每 $10 的交易量即可获得一次抽奖资格。更多详情请访问 {blog}。'
      },
      tesla: {
        blog: 'blog',
        ended: '已结束',
        title: '赢取一辆特斯拉！',
        description:
          '参与交易赢取特斯拉！活动时间为 11 月 26 日 15:00 UTC 至 12 月 6 日 15:00 UTC，PnL 最高的交易员将赢得一辆 Tesla Model 3。更多详情请访问 {blog}。'
      },
      ownYourAsset: {
        blog: 'blog',
        ended: '已结束',
        title: '掌控资产，把握未来。',
        description:
          '参与 Helix 交易挑战，瓜分 $50,000 奖池。活动时间为 2025 年 2 月 21 日 18:00 UTC 至 3 月 3 日 18:00 UTC。每累计 $1,000 的交易量可获得一次抽奖资格，赢取 $1,000。更多详情请访问 {blog}'
      }
    }
  },
  referral: {
    share: '分享',
    approve: '确认',
    referNow: '立即邀请',
    noReferrals: '暂无邀请记录',
    referralLink: '邀请链接',
    referAndEarn: '邀请赚奖励',
    confirmReferral: '确认关联邀请',
    referralDetails: '邀请详情',
    scanToJoin: '扫码注册 Helix，或',
    yourReferralLink: '您的邀请链',
    checkAvailability: '检查可用性',
    affiliatedAddress: '关联地址',
    startEarningToday: '从今天开始赚取奖励',
    createReferralLinkPlaceholder: 'BULLISH',
    customReferralCode: '自定义邀请码',
    chooseDifferentLink: '选择其他链接',
    dashboardTitle: '邀请朋友，赚取奖励',
    referralLinkAvailable: '邀请链接可用！',
    lettersAndNumbersOnly: '仅支持字母和数字',
    confirmAndGenerateLink: '确认并生成链接',
    createReferralLinkTitle: '创建您的邀请链接',
    trackYourReferrals: '追踪您的邀请记录和佣金收益',
    shareYourReferralLink: '分享您的邀请链接，邀请好友加入。',
    referralCodeMaxLengthMessage: '邀请码最多支持 32 个字符',
    dashboardSubtitle: '邀请用户赚取奖励。成为联盟成员可获得更高回报。',
    createReferralLinkSubtitle:
      '选择一个独特的链接，用于追踪您的邀请记录。让它易记、易传播。',
    rewardsTooltipContent:
      '您通过成功邀请赚取的总佣金。奖励根据受邀用户的交易活动发放。',
    referralLinkAvailableDescription:
      '您的邀请码 {baseUrl}/ref/{referralCode} 可用。是否使用该链接？',
    confirmReferralDescription:
      '您将使用链接 {baseUrl}/ref/{referralCode} 被邀请。请确认是否同意关联此地址。',
    table: {
      wallets: '钱包地址',
      'join-date': '加入日期',
      commission: '佣金收益'
    },
    myStats: {
      title: '我的数据',
      rewardsEarned: '已赚取奖励',
      tradersReffered: '已邀请好友数量'
    },
    referFriends: {
      title: '如何邀请好友',
      step3Title: '自动领取奖励',
      step2Title: '邀请好友赚取 40%',
      step1Title: '分享您的邀请链接',
      step2Description: '您可以邀请任意数量的好友。',
      description1: '邀请朋友们使用 Helix 交易',
      step1Description: '您可以生成专属邀请链接。',
      description2: ' 并获得引荐好友手续费的 40% 作为佣金。',
      step3Description: '奖励将自动发放至您的钱包。'
    },
    shareModal: {
      title: '邀请您的好友！',
      customizeYourText: '自定义您的文案',
      description: '扫码加入 Helix，一起交易吧！',
      defaultText:
        '赚取奖励，随时提现。邀请好友加入 Helix 交易并赚取他们手续费的 40% 作为佣金。'
    }
  },
  lpRewards: {
    volume: '交易量',
    overall: '总计',
    address: '地址',
    rewards: '奖励',
    ongoing: '进行中',
    title: 'LP 奖励',
    letsGo: '开始吧！',
    round: '第 {round} 轮',
    myRewards: '我的奖励',
    allRewards: '全部奖励',
    estRewards: '预计奖励',
    totalVolume: '总交易量',
    rewardStats: '奖励统计',
    addLiquidity: '添加流动性',
    rewardsRound: '奖励/轮次',
    campaignRules: '活动规则',
    rewardsDetails: '奖励详情',
    rewardsToClaim: '可领取奖励',
    volumeThisRound: '本轮交易量',
    lastUpdated: '最后更新时间：{date}',
    dashboardTitle: 'LP 奖励看板',
    myRewardsCount: '我的奖励（{rewards}）',
    noActiveCampaigns: '当前无进行中的活动',
    endTimeForRound: '第 {round} 轮结束时间',
    totalRewardsAllTime: '历史总奖励',
    totalRewardsThisRound: '本轮总奖励',
    totalRewardsOfRound: '第 {round} 轮总奖励',
    helixLpRewardsRound: 'Helix 第 {round} 轮 LP 奖励',
    description: '通过交易不同现货市场赚取奖励',
    rewardsPending:
      'LP 奖励处理中：该交易对的奖励正在结算，资金发放可能在轮次结束后一周内完成。',
    legacyBotWarning:
      '警告：您正在错过 LP 奖励！请停止 Legacy 市场的交易策略，切换至新市场重新创建策略以开始赚取奖励。',
    roundIsLive:
      '{round1} 已启动！查看本轮新增的交易市场！如需领取 {round2} 的奖励，请前往本页的 {myRewards}。',
    table: {
      liquidity: {
        market: '市场',
        volume: '交易量',
        rewards: '奖励',
        'active-bots': '运行中的机器人'
      },
      dashboard: {
        market: '市场',
        volume: '交易量',
        rewards: '奖励',
        'est-rewards': '预计奖励'
      }
    }
  },
  portfolio: {
    swaps: '闪兑',
    staked: '已质押',
    positions: '持仓',
    spotOrders: '现货订单',
    assetsFrom: '资产来源',
    totalValue: '总价值',
    tradeHistory: '交易历史',
    orderHistory: '订单历史',
    noOpenOrders: '查无订单',
    fundingHistory: '资金费历史',
    advancedOrders: '高级订单',
    noPositionsOpen: '查无仓位',
    derivativeOrders: '衍生品订单',
    noTransferHistory: '未找到转账记录',
    noFundingHistory: '未找到资金费记录',
    showUnverifiedAssets: '显示未验证资产',
    notAvailableinAuthZOrAutoSignMode: '在访问控制模式或自动签名模式下不可用',
    tab: {
      pnl: '盈亏',
      account: '账户'
    },
    home: {
      stakedInj: '已质押 INJ',
      yieldBearingUsdt: '收益型 USDT',
      unrealizedPositions: '未实现持仓',
      volume: {
        title: '交易量（每周）'
      },
      balance: {
        title: '资产总价值'
      },
      tradableBalance: {
        title: '可交易金额'
      },
      pnl: {
        title: '交易盈亏',
        tooltip:
          '投资组合页面的盈亏计算反映了自 2024 年 5 月 29 日以来在 Helix 上开平仓所产生的大致已实现盈亏。该计算仅供参考，不应作为税务申报的依据。'
      }
    },
    balances: {
      netWorth: '净资产',
      transferToMain: '转入主账户'
    },
    subaccounts: {
      addSubaccountOrTransfer: '添加子账户 / 转账',
      accountEndBot:
        '如需将资金转入主账户，请先停止当前的现货网格交易机器人。该操作将自动发起资金转账。',
      description:
        '这是一个关联至主账户的子账户，用于独立管理和交易数字资产。要激活该账户，需先转入资金。可在 FAQ 中了解更多关于子账户的内容。'
    },
    settings: {
      title: '设置',
      account: '账户',
      notAvailableinAuthZMode: '在访问控制模式下不可用',
      preferences: {
        title: '偏好设置',
        eip712: {
          title: '启用 EIP-712 签名'
        },
        autosign: {
          description: '自动签名功能可使您在交易时无需每次手动确认钱包交易。',
          tooltip: '启用后，最长 3 天内无需为每笔交易签名，且可随时关闭此功能。'
        },
        thousandsSeparator: {
          title: '千位分隔符',
          description:
            '为长数字添加逗号，提升可读性。例如：1234567 显示为 1,234,567'
        },
        gridTradingSubaccounts: {
          title: '显示网格交易子账户',
          description: '展示专用于网格交易的子账户列表'
        }
      }
    },
    filters: {
      byType: '按类型筛选',
      bySide: '按方向筛选',
      byAsset: '按资产筛选',
      byMarket: '按市场筛选',
      cleanFilters: '清除筛选条件'
    },
    connectMobile: {
      grantAccess: '授权访问',
      scanCode: '扫描二维码以继续',
      scanQRCode: '请使用手机扫描此二维码以连接钱包'
    },
    bankTransfer: {
      title: '转账',
      enterAddress: '请输入 Injective 地址',
      doubleCheck: '请再次确认地址，发送至错误地址的代币将无法找回',
      memo: {
        title: 'Memo',
        required: '必填',
        placeholder: '输入 memo（大多数中心化交易所都需要填写）'
      }
    },
    duration: {
      '1D': '1天',
      '1W': '1周',
      '1M': '1月'
    },
    walletHistory: {
      subaccountDepositType: '主钱包转至子账户',
      subaccountWithdrawalType: '子账户转至主钱包',
      subaccountInternalTransferType: '子账户间转账'
    },
    keyStats: {
      title: '关键数据',
      allTimePnl: '历史累计盈亏',
      totalVolume: '累计交易量',
      totalEquity: '总资产净值',
      stakingAccount: '质押账户',
      spotAccountEquity: '现货账户净值',
      perpsAccountEquity: '合约账户净值'
    },
    authZ: {
      title: '访问控制管理',
      description: '授权其他钱包地址部分或全部权限，以代表您进行交易操作',
      revoke: '撤销',
      actions: '操作',
      grantee: '被授权人',
      granter: '授权人',
      revokeAll: '全部撤销',
      connectAs: '连接身份',
      noGrants: '未发现任何授权',
      authZAs: '以 {address} 的身份进行访问控制',
      granteeAddress: '被授权钱包地址',
      grantedFunctions: '已授权的功能',
      connectMobile: '连接手机',
      addNewGrantee: '添加新的被授权地址',
      addGranteeAddress: '添加被授权地址',
      viewGrantedFunctions: '查看已授权功能',
      notAvailableinAutoSignMode: '在自动签名模式下不可用'
    },
    autoSign: {
      title: '自动签名',
      durationDescription: '自动签名功能激活后有效期为 3 天',
      pageTitle: '自动签名：自动批准交易',
      content1: {
        description1: '启用后，您可以在使用 Helix 时无需手动签名',
        description2: '每笔交易，最长持续 3 天'
      },
      content2: {
        title: '您可以用于以下操作：',
        description1: '开仓/平仓（现货与永续交易对）',
        description2: '设置限价单',
        description3: '创建止盈/止损（TP/SL）订单'
      },
      content3: {
        title: '注意：',
        description1: '不支持闪兑和交易机器人操作',
        description2: '为确保安全，自动签名会话将在 3 天后自动过期',
        description3: '过期后您可以随时开始新的会话'
      },
      expiredToast: {
        settings: '设置',
        title: '自动签名会话已过期',
        description: '您可以在 {settings} 中开始新会话'
      }
    },
    table: {
      fundingHistory: {
        time: '时间',
        pair: '交易对',
        payment: '支付金额'
      },
      subaccounts: {
        name: '子账户名称',
        address: '子账户地址',
        'total-usd': '总资产（美元）'
      },
      historySwap: {
        fee: '手续费',
        time: '时间',
        route: '闪兑路径',
        outgoing: '卖出',
        incoming: '买入'
      },
      historyWallet: {
        time: '时间',
        type: '类型',
        asset: '资产',
        amount: '金额',
        origin: '来源地址',
        destination: '目标地址'
      },
      balance: {
        total: '总额',
        assets: '资产',
        staked: '已质押',
        available: '可用',
        'staked-usd': '已质押（美元）',
        'total-usd': '总价值（美元）',
        'unrealized-pnl': '未实现盈亏',
        'used-or-reserved': '已用/预留'
      },
      spotOpenOrder: {
        side: '方向',
        price: '价格',
        chase: '追单',
        action: '操作',
        market: '市场',
        amount: '数量',
        filled: '已成交',
        unfilled: '未成交',
        'total-amount': '总数量'
      },
      spotOrderHistory: {
        type: '类型',
        side: '方向',
        price: '价格',
        total: '总金额',
        status: '状态',
        market: '市场',
        amount: '数量',
        'last-updated': '最后更新',
        'trigger-condition': '触发条件'
      },
      spotTradeHistory: {
        fee: '手续费',
        time: '时间',
        pair: '交易对',
        type: '类型',
        side: '方向',
        total: '总金额',
        price: '价格',
        amount: '数量'
      },
      futuresOpenOrder: {
        side: '方向',
        price: '价格',
        total: '总金额',
        chase: '追单',
        action: '操作',
        market: '市场',
        amount: '数量',
        filled: '已成交',
        unfilled: '未成交',
        leverage: '杠杆'
      },
      futuresOrderHistory: {
        type: '类型',
        side: '方向',
        price: '价格',
        total: '总金额',
        status: '状态',
        market: '市场',
        amount: '数量',
        'last-updated': '最后更新',
        'trigger-condition': '触发条件'
      },
      futuresTradeHistory: {
        fee: '手续费',
        time: '时间',
        type: '类型',
        side: '方向',
        price: '价格',
        total: '总金额',
        market: '市场',
        amount: '数量',
        pnl: '已平仓盈亏'
      },
      futuresAdvancedOrders: {
        type: '类型',
        side: '方向',
        price: '价格',
        total: '总金额',
        action: '操作',
        market: '市场',
        amount: '数量',
        leverage: '杠杆',
        'trigger-condition': '触发条件'
      },
      position: {
        side: '方向',
        'tp-or-sl': '止盈/止损',
        market: '市场',
        mark: '标记价格',
        entry: '开仓价格',
        leverage: '杠杆',
        contracts: '合约数量',
        margin: '仓位保证金',
        'total-usd': '总价值（美元）',
        'liquidation-price': '强平价格',
        'close-position': '平仓',
        'unrealized-pnl': '未实现盈亏'
      }
    }
  },
  navigation: {
    spot: '现货',
    swap: '闪兑',
    trade: '交易',
    swaps: '闪兑记录',
    stocks: '股票',
    points: '积分',
    orders: '订单',
    markets: '市场',
    history: '历史记录',
    balances: '资产',
    settings: '设置',
    portfolio: '投资组合',
    positions: '持仓',
    myAccount: '我的账户',
    disconnect: '断开连接',
    derivative: '衍生品',
    noTierLevel: '无 VIP 等级',
    subaccounts: '子账户',
    leaderboard: '排行榜',
    tradingBots: '交易机器人',
    fundingHistory: '资金费率历史',
    subaccountHistory: '子账户历史记录',
    makerTakerFee: '-{maker}% 做市 / -{taker}% 吃单',
    more: {
      olp: 'OLP',
      title: '更多',
      vaults: '金库',
      bridge: '跨链桥',
      deposit: '充值',
      referral: '推荐邀请',
      lpRewards: 'LP 奖励'
    }
  },
  footer: {
    blog: 'Blog',
    v2: ' Version 2.0',
    support: '支持',
    docs: 'Helix 文档',
    explorer: '区块浏览器',
    resources: '资源',
    community: '社区',
    operational: '系统状态',
    feeDiscounts: '手续费折扣',
    institutional: '机构服务',
    privacyPolicy: '隐私政策',
    apiDocumentation: 'API 文档',
    termsAndConditions: '用户条款',
    helixProvides: '注：Helix 可在 Injective DAO 批准的多个市场中提供做市返佣。'
  },
  tradingBots: {
    all: '全部',
    time: '时间',
    user: '用户',
    auto: '自动',
    lower: '下限',
    upper: '上限',
    active: '运行中',
    manual: '手动',
    endBot: '停止机器人',
    removed: '已移除',
    pending: '待开始',
    overview: '概览',
    showcase: '示例',
    duration: '持续时间',
    spotGrid: '现货网格',
    totalTvl: '总 TVL',
    totalPnl: '总收益',
    totalRoi: '总回报率',
    moreInfo: '查看更多',
    gridMode: '网格模式',
    title: '更聪明的交易',
    available: '可用',
    geometric: '等比网格',
    startTime: '启动时间',
    gridBound: '网格范围',
    investment: '投资金额',
    priceRange: '价格区间',
    activeBots: '运行中机器人',
    lowerPrice: '最低价格',
    upperPrice: '最高价格',
    lowerBound: '下限价格',
    upperBound: '上限价格',
    gridNumber: '网格数量',
    stopReason: '停止原因',
    futuresGrid: '合约网格',
    totalProfit: '总利润',
    volumeBoost: '成交量加速器',
    totalAmount: '总数量',
    totalAssets: '总资产',
    viewDetails: '查看详情',
    profitGrid: '网格间距',
    gridDetails: '网格详情',
    assetsInBot: '机器人中的资产',
    currentPrice: '当前价格',
    copyStrategy: '复制策略',
    noActiveBots: '暂无运行中机器人',
    enableLpMode: '启用 LP 模式',
    trailingBound: '追踪区间',
    setUpNewBot: '设置新机器人',
    liquidityGrid: '流动性网格',
    topPerformers: '热门策略',
    initialAmount: '初始金额',
    numberOfGrids: '网格数量',
    createStrategy: '创建策略',
    enableTrailing: '启用追踪',
    learnMoreHere: '在此了解更多。',
    removeStrategy: '移除策略',
    lowerPriceStop: '止损下限价格',
    upperPriceStop: '止损上限价格',
    saveOnFees: '调整投入金额',
    noStrategies: '未找到策略',
    optimizedAmounts: '优化金额',
    totalBotsCreated: '创建的机器人总数',
    replicateStrategy: '复制策略',
    buySymbolOnStop: '止损时买入 {symbol}',
    insufficientFunds: '资金不足',
    approximateProfit: '预估利润',
    initialEntryPrice: '初始入场价',
    trailingPriceRange: '动态价格区间',
    createYourStrategy: '创建策略',
    noActiveStrategies: '暂无运行中的策略',
    keepOriginalAmounts: '保留原始金额',
    useFeeOptimizedAmounts: '使用推荐金额',
    sellAllSymbolOnStop: '止损时卖出所有 {symbol}',
    exceededMaxRetries: '市场波动过大',
    copyParametersToManual: '复制参数至手动模式',
    botCreationConfirmation: '机器人创建确认',
    strategyRemovalInitiated: '策略移除已启动',
    sellSymbolUponTermination: '终止时卖出 {symbol}',
    marketConditionsNotSupported: '不支持当前市场条件',
    minInvestmentDescription: "最低投资金额 {symbols} ≥ {'$'}{amount}",
    youCanCloseThisNotification: '您可以关闭此通知并继续使用平台。',
    confirmationDescription: '请仔细阅读以下信息，然后确认继续操作。',
    autoModeHeader: '以下参数是根据过去 30 天的价格自动生成。',
    nOfGridsTooltip:
      '网格数量越多，挂单越密集，更容易捕捉价格波动，但也需要更多初始资金。',
    yourTradingStrategyIsBeingRemoved:
      '您的交易策略正在移除中，系统将自动完成该操作，可能需数分钟。',
    disclaimer:
      '我已阅读并同意风险免责声明，并理解所有参数选择和投资决策由用户自行承担。',
    description:
      '这是您在 Helix 上自动交易的控制中心。您可以监控运行中的机器人、追踪 LP 奖励，并查看社区热门策略以获得灵感。',
    topPerformersDescription:
      '向成功者学习。查看哪些策略和参数当前在 Helix 上表现最佳，并据此优化自己的方案或复制创建新机器人。',
    botType: {
      spotGrid: '现货网格',
      futuresGrid: '合约网格',
      liquidityGrid: '流动性激励'
    },
    myLpRewards: {
      viewAll: '查看全部',
      title: '我的 LP 奖励',
      volumeAllTime: '总交易量',
      rewardsAllTime: 'LP 奖励总额',
      volumeThisRound: '本轮交易量',
      totalEstRewards: '预计奖励总额',
      roundEndTime: '第 {round} 轮结束时间'
    },
    sgt: {
      lpModeTooltip:
        '启用 LP 模式后，策略在设置期间将避免再平衡，并创建不对称的买入和卖出订单，模拟流动性提供者的行为。',
      lowerPriceStopTooltip:
        '设置一个价格下限，低于该价格时将停止创建新的买单。这不是传统意义上的‘止损’，而是为了在价格低于您的网格区间时暂停买入操作。',
      upperPriceStopTooltip:
        '设置一个价格上限，高于该价格时将停止创建新的卖单。该机制相当于网格交易的价格天花板，超出区间后暂停卖出操作。',
      minInvestmentTooltip:
        "最低投资额：起始为 {'$'}{amount}。每多 10 个网格，增加 $5，最多支持 100 个网格。金额按所选资产 {assets} 的美元价值计算。",
      balancedFeesMessage:
        '您的初始投资额为 {initialInvestment} 美元。根据设置的价格区间和网格数量，系统建议的初始资产分配为 {quoteAmount} {quote} 和 {baseAmount} {base}。建议金额基于机器人在初始化时将创建的买卖订单，同时尽量贴近您原始投入金额的总价值。',
      investmentTooltip:
        '使用 USDT 与 INJ 混合资金可降低策略执行中的手续费。这不是平台新收费，而是通过减少币种间的转换 Gas 成本来优化部署效率。',
      gridModeTooltip:
        '算术模式中，任意相邻两个网格之间的价格差是固定的；等比模式中，任意相邻两个网格之间的价格比是固定的。',
      tabs: {
        liveSpotGrid: '运行中现货网格',
        spotGridHistory: '现货网格历史',
        liveFuturesGrid: '运行中合约网格',
        futuresGridHistory: '合约网格历史'
      },
      modes: {
        perpetual: '永续模式',
        geometric: '等比模式',
        arithmetic: '算术模式',
        arithmetic_lp: '算术 LP 模式',
        trailing_arithmetic: '追踪算术模式',
        trailing_arithmetic_lp: '追踪算术 LP 模式'
      },
      optimization: {
        optimizeBalance: '优化资产配置',
        balanceOptimized: '已优化资产',
        balanceStability: '资产平衡稳定性',
        confirmAndAdjust: '确认并调整',
        balanceNeedsAdjusting: '资产需要调整',
        optimizeBalanceTitle: '优化策略资产配置',
        adjustYourAvailableBalance:
          '调整您当前的 [{base}] 与 [{quote}] 资产余额',
        yourBalanceIsOptimal:
          '资产分配良好，可在设定价格区间内实现最佳网格效率',
        yourBalanceIsOffBy: '您的资产分配与 50/50 最佳比例相差 {percentage}%',
        balancedTooltip:
          '资产平衡稳定性表示您在提供流动性时资产的对称程度。比例越高，代表更能抗市场波动，减少频繁再平衡需求。',
        optimizeBalanceBody:
          '为了降低交易费用并提升执行效率，我们建议重新平衡您的资产。这是技术层面的优化调整，并不构成任何投资建议或收益承诺。'
      }
    },
    liquidityBots: {
      title: '交易量提升机器人',
      description:
        '轻松提升交易量。交易量提升机器人可自动提供流动性，在您设定的价格区间内执行交易，捕捉市场机会并保持活跃度。',
      deposit: '充值',
      passive: '保守型',
      moderate: '中性型',
      duration: '运行时间',
      createBot: '创建机器人',
      aggressive: '激进型',
      selectPair: '选择交易对',
      timeCreated: '创建时间',
      finalBalance: '最终余额',
      depositAmount: '充值金额',
      trailingUpper: '追踪上限',
      trailingLower: '追踪下限',
      currentBalance: '当前余额',
      setLiquidityBot: '设置流动性机器人',
      volatilityStrategy: '波动性策略',
      trailingBoundaries: '跟踪价格区间',
      upToRewards: '每周最多可获得 {amount} 个 {symbol} 奖励',
      depositDescription: '您可以用单一资产添加流动性'
    }
  },
  leaderboard: {
    myStats: '我的数据',
    title: '排行榜',
    viewMore: '查看更多',
    helix: 'helixapp.com',
    timestamp: '时间戳',
    startTrading: '开始交易',
    privacyPolicy: '隐私政策',
    rulesTermsAndConditions: '规则、条款与条件',
    refresh: '排行榜每小时整点更新一次',
    description: 'Helix 根据链上交易盈利情况（PnL）对交易员进行排名',
    tradeAndWin: '还没有上榜？快来 Helix 交易赢取排名吧！',
    blocked:
      '美国、英国及官方 {terms} 中列出的其他部分国家/地区的居民无法参与或赢得本次竞赛。',
    tabs: {
      leaderboard: '盈亏排行榜',
      'leaderboard-competition': '交易竞赛',
      'leaderboard-past-competitions': '往期竞赛'
    },
    pnl: {
      share: '分享',
      tradingPnl: '交易盈亏',
      noPnlData: '暂无盈亏数据',
      allTime: '自 2024 年 8 月 1 日 00:00 UTC 起',
      currentDuration: '交易盈亏（{duration}）',
      lastUpdated: '最近更新：{lastUpdatedDate}',
      timePeriod: '统计时间：{startDate} - {endDate}',
      duration: {
        '1D': '今日',
        ALL: '全部时间',
        '1W': '本周',
        '1M': '本月'
      }
    },
    competition: {
      winner: '获胜者',
      unranked: '未上榜',
      currentLeaderMobile: '🔥',
      currentLeaderFlame: '🔥🔥',
      keepGoing: '继续加油 💪',
      tradingVolume: '交易量',
      currentLeader: '当前领先者',
      competitionDuration: '剩余时间： {duration}',
      noVolumeData: '暂无交易竞赛结果',
      termsAndConditionsApply: '适用的用户条款',
      checkBackLater: '请稍后回来查看您是否获胜！',
      competitionBeginning: '竞赛即将开始...',
      noPastCompetition: '当前暂无往期竞赛。',
      thanksForParticipating: '感谢参与！很遗憾这次您没有获胜。',
      noCompetition: '目前没有正在进行的竞赛，请稍后再来查看！',
      firstHourOfCampaign:
        '竞赛现已开始。排行榜将在 {afterFirstHour} 开始显示活动数据。',
      additionalEntriesTooltip:
        '这些是您在竞赛期间，因参与一个或多个额外奖励时段而获得的额外抽奖机会。',
      winnerModal: {
        emailPlaceholder: '您的邮箱地址',
        namePlaceholder: '您的姓名',
        bannerDescription:
          '恭喜！您是本次排行榜竞赛的获胜者之一。本次您赢得了 {prize}。点击开始领取奖品！',
        getStarted: {
          cta: '开始领取',
          title: '恭喜!',
          description:
            '您是 {competition} 的获胜者之一！要领取您的 {prize}，请提供更多信息。'
        },
        contactInfo: {
          cta: '确认提交',
          title: '需要联系信息',
          description:
            '为遵循竞赛官方 {terms}，请填写联系信息以便验证身份并发放奖品。同时，请阅读并确认您已同意 {privacyPolicy} 后点击下方按钮提交。'
        }
      }
    },
    header: {
      rank: '排名',
      entries: '抽奖机会',
      address: '地址',
      weeklyROI: '本周投资回报率',
      volume: '交易量（美元）',
      tradingPnl: '交易盈亏（美元）',
      numberOfEntries: '抽奖机会',
      allMarketsVolume: '所有市场交易量（美元）'
    },
    footer: {
      onlyTop100Connect: '请连接钱包查看您的排名数据',
      onlyTop100: '排行榜仅显示前 100 名参与者'
    }
  },
  maintenance: {
    title: '正在维护中',
    governance: '治理提案',
    subscribe: '订阅提醒',
    subscribeDescription: '通过 Notifi 获取实时通知',
    governanceDescription: '查看最新链升级的详细信息',
    footer: '我们正在优化 Helix。感谢您的耐心，平台将很快恢复服务！',
    description: '我们正在进行系统更新。在此期间，部分功能将暂时不可用。'
  },
  feeDiscounts: {
    off: '无折扣',
    tier: '等级',
    maker: '挂单',
    taker: '吃单',
    myFeeTier: '我的手续费等级',
    currentApr: '当前 APR',
    pageTitle: '手续费折扣',
    updateDaily: '每日更新',
    stakedAmount: '质押数量',
    tradingVolume: '交易量',
    myStakedAmount: '我的质押数量',
    lastUpdatedAt: '上次更新时间',
    inPastDays: '过去 {days} 天内',
    myTradingVolume: '我的交易量',
    viewFeeDiscounts: '查看手续费折扣',
    feesTakerMaker: '手续费（吃单 / 挂单）',
    makerRateDiscount: '挂单费率折扣',
    takerRateDiscount: '吃单费率折扣',
    feesTakerMakerPercent: '{takerFee}% / {makerFee}%',
    makerRateDiscountTooltip: '根据手续费等级享受的挂单费率折扣',
    takerRateDiscountTooltip: '根据手续费等级享受的吃单费率折扣.',
    pageDescriptionWarning:
      '请注意，挂单手续费折扣仅适用于挂单费率为非负数的市场',
    pageDescription: '手续费计算基于用户质押的 INJ 数量及过去 28 天的总交易量',
    tradingVolumeTooltip:
      '按 28 天滚动周期计算的总交易量。目前仅包含 USD 报价市场。',
    stakedAmountTooltip:
      '所需质押的 INJ 数量。质押 INJ 可增强协议安全性、赚取奖励，并提升手续费等级。'
  },
  tradeAndEarn: {
    title: 'Trade & Earn！',
    description: '通过在现货与永续交易页面交易或使用交易机器人赚取 INJ 奖励',
    pts: '积分',
    stakeMore: '质押更多',
    makerPoints: '挂单积分',
    takerPoints: '吃单积分',
    estRewards: '预计奖励',
    campaignAsOf: '截至 {date}',
    estRewardsStake: '预计奖励',
    pendingRewards: '待领取奖励',
    emptyPendingRewards: '暂无待领取奖励',
    pendingMaxCampaignRewards: '本轮总奖励分配',
    myRewardPoints: '我的奖励积分 / 总奖励积分',
    stakeTotalToReceiveFullAmount: '质押共计 {total} INJ 以领取全部奖励',
    sunset: '感谢参与 Trade & Earn！敬请期待更多面向 Helix 用户的激励活动。',
    pendingMaxCampaignRewardsTooltip:
      '上一个周期分配的 INJ 总额。奖励将在归属期结束时发放。',
    myRewardPointsTooltip:
      '您在本次活动中获得的当前积分，以及本活动的总积分。每轮活动开始时，积分将重置为 0。',
    estRewardsStakeTooltip:
      '根据您当前的奖励积分与总奖励积分之比 × 总分配奖励，估算本地址的奖励数额。假设您后续的积分增长速度与总积分增长相同。为保持或提高奖励，请持续维持当前或更高的交易活跃度。奖励上限为 {maxRewards} INJ 或等值质押 INJ（取较高者）。'
  },
  institutional: {
    benefits: '优势',
    talkToUs: '联系我们',
    modalTitle: '取得联系',
    getInTouch: '取得联系',
    learnMore: '想了解更多？',
    trustedByTheBest: '值得信赖的选择',
    heroTitle: '真正链上的机构级金融平台',
    allRightsReserved: 'Injective Labs. All Rights Reserved.',
    modalDescription: '直接联系 Helix 的机构服务团队。',
    whyFinancialInstitutionsChooseHelix: '为什么金融机构选择 Helix',
    heroSubtitle:
      '在唯一完全去中心化的网络中接触无限加密资产、永续合约和结构化产品。',
    permisionedMarketsTitle: '许可市场',
    permisionedMarketsBody:
      'Helix 独家提供机构级许可市场通道，使您可与专业认证的交易对手无缝互动。',
    multiAssetSupportTitle: '支持多种资产',
    multiAssetSupportBody:
      '跨多个区块链网络访问多样的链上资产、衍生品和结构化产品。',
    onChainTransparencyTitle: '链上透明性',
    onChainTransparencyBody:
      '通过唯一完全链上处理交易、结算和资产发行的平台，最大程度保障您的资产安全。',
    fullyCompliantTitle: '链上透明性',
    fullyCompliantBody:
      '通过唯一完全链上处理交易、结算和资产发行的平台，最大程度保障您的资产安全。',
    instantSettlementTitle: '即时结算',
    instantSettlementBody: '执行防 MEV 操控的交易，享受行业最快的结算速度。',
    robustSecurityTitle: '强大安全性',
    robustSecurityBody:
      '使用非托管平台，配合最严格的安全措施，确保您的资产始终掌握在您自己手中。',
    superiorInfrastructureTitle: '卓越基础设施',
    superiorInfrastructureBody:
      '利用 Helix 为最专业金融机构和交易员打造的定制化基础设施。',
    form: {
      email: 'Email',
      company: '公司',
      lastName: '姓',
      firstName: '名'
    }
  },
  common: {
    or: '或',
    and: '与',
    pnl: '盈亏',
    max: '最大',
    docs: '文档',
    back: '返回',
    base: '基础资产',
    copy: '复制',
    here: '这里',
    link: '链接',
    view: '查看',
    total: '总计',
    quote: '计价资产',
    value: '价值',
    close: '关闭',
    ready: '就绪',
    claim: '领取',
    amount: '数量',
    enable: '启用',
    submit: '提交',
    search: '搜索',
    cancel: '取消',
    sortBy: '排序方式',
    connect: '连接',
    details: '详情',
    runtime: '运行时间',
    claimed: '已领取',
    deposit: '存入',
    confirm: '确认',
    disabled: '已禁用',
    inactive: '未激活',
    transfer: '转账',
    withdraw: '提现',
    tradeNow: '立即交易',
    active: '运行中',
    download: '下载',
    ascending: '升序',
    learnMore: '了解更多',
    descending: '降序',
    tradingDocs: '交易文档',
    unauthorized: '未授权',
    baseAndQuote: '基础资产与计价资产',
    sortDirection: '排序方向',
    dontShowAgain: '不再显示',
    showMoreContext: '显示更多',
    acknowledgeTerms: '我已阅读并同意条款',
    pagination: '第 {from} 至 {to} 条，共 {totalCount} 条',
    day: '天',
    hour: '小时',
    minute: '分钟',
    second: '秒',
    account: {
      main: '主账户',
      subaccount: '子账户',
      mainSubaccount: '主子账户',
      subaccountId: '子账户 {subaccountId}',
      subaccountTransfer: '子账户转账',
      noAssetToTransfer: '此子账户暂无可转资产'
    },
    modal: {
      terms: {
        privacyPolicy: '隐私政策',
        termsAndCondition: '使用条款',
        title: '此外，您在此声明、保证并同意以下内容：',
        acknowledge_1:
          '您不是美国（关于永续合约交易）、英国（除非为投资专业人士）或 Helix 使用条款中定义的受限地区的居民、所在位置、注册机构或注册代理。',
        acknowledge_2:
          '您当前以及未来在位于美国（关于永续合约交易）、英国（除非为投资专业人士）或受限地区时不会访问本网站或使用 helixapp.com。',
        acknowledge_3:
          '您不会现在或未来使用虚拟专用网络（VPN）或其他方式隐藏你来自受限地区的真实位置。',
        acknowledge_4:
          '您在所在司法辖区的法律允许下合法访问本网站并在 helixapp.com 上交易。',
        acknowledge_5:
          '您了解使用杠杆、参与永续合约和交易数字资产所涉及的风险。',
        disclaimerNote:
          '连接钱包即表示您已阅读、理解并同意 Helix 的 {0} 及 Injective Labs 的 {1}，并将受其约束。'
      },
      postOnlyMode: {
        title: '仅挂单模式！',
        description:
          '请注意，在 Injective Volan 主网升级后的约 2000 个区块（约 30 分钟）内，仅支持挂单下单。'
      },
      geoRestricted: {
        cta: '我知道了',
        title: 'Helix 暂不支持你所在地区',
        description:
          '由于监管要求，我们暂无法在你所在地区提供 Helix 服务。我们正在努力拓展服务范围并确保合规。感谢你的关注，期待你加入我们的全球社区。如有未平仓头寸，请前往资产页进行处理。'
      },
      devMode: {
        connect: '连接',
        enterPrivateKey: '输入私钥',
        connectWithPrivateKey: '使用私钥连接',
        enterInjectiveAddress: '输入 Injective 地址'
      },
      ninjaPass: {
        later: '稍后验证',
        verifyNow: '立即验证',
        congratulations: '恭喜! 🎉',
        title: '您赢得了一张专属 Ninja Pass 🥷',
        description:
          '该通行证可作为你参与 Injective 独家活动、产品、空投等惊喜的入场券。'
      },
      onboarding: {
        injectiveBridge: 'Injective 跨链桥',
        processing: '转账处理中',
        closeAndContinue: '关闭并继续',
        success: '交易已确认',
        depositInjNetworkAsset: '存入 INJ 网络资产',
        processingMessage: '处理时间超出预期，请耐心等待',
        depositNowDescription:
          '您可以从支持 Injective 网络的任意平台转入 INJ，包括部分交易所。',
        processingMessageInfo:
          '您的转账正在后台处理中，可安全关闭此窗口。你可在余额页查看桥接金额，或在此查看跨链桥历史记录：',
        qr: {
          bridge: '跨链桥',
          cta: '使用银行卡购买 INJ'
        }
      }
    }
  },
  notFound404: {
    title: '页面未找到',
    backToHome: '返回首页',
    description: '您访问的页面不存在'
  }
}
